import { render } from "./keywordAddtotaskViewMask.vue?vue&type=template&id=9b51f5e2&scoped=true"
import script from "./keywordAddtotaskViewMask.vue?vue&type=script&lang=js"
export * from "./keywordAddtotaskViewMask.vue?vue&type=script&lang=js"

import "./keywordAddtotaskViewMask.vue?vue&type=style&index=0&id=9b51f5e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b51f5e2"]])

export default __exports__